import React, { useState } from 'react';
import { useStripe } from '@stripe/react-stripe-js';
import { useNavigate } from 'react-router-dom';

export function PaymentForm({ amount, onSuccess, onError, selectedPlan, currentSubscription }) {
  const stripe = useStripe();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!stripe) return;

    setLoading(true);
    try {
      // Get the session ID first
      let sessionId;
      try {
        sessionId = await onSuccess();
      } catch (sessionError) {
        // Handle authentication errors
        if (sessionError.message.includes('Authentication failed') || 
            sessionError.message.includes('Invalid token')) {
          // Force user to log in again
          alert('Your session has expired. Please log in again to continue.');
          navigate('/login');
          return;
        }
        
        // Handle subscription errors
        if (sessionError.redirectToAccount) {
          alert(sessionError.error || 'You already have an active subscription.');
          navigate('/account');
          return;
        }
        
        throw sessionError;
      }

      // Redirect to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        sessionId: sessionId
      });

      if (error) {
        onError(error);
      }
    } catch (err) {
      onError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className='textbox container'>
      <form onSubmit={handleSubmit} style={{ maxWidth: '70%', margin: '0 auto' }}>
        {amount > 0 && (
          <p>Amount to pay: €{amount}</p>
        )}
        <button className="button" type="submit" disabled={!stripe || loading}>
          {loading ? 'Processing...' : 'Proceed to Payment'}
        </button>
      </form>
    </div>
  );
}